import type { CommentReply } from '@/types/review/ReviewAnswer';

import { api } from '@/api/api';

export interface CreateCommentReplyParams {
    reviewQuestionAnswerId: string;
    content: string;
}

export default {
    async createCommentReply({
        reviewQuestionAnswerId,
        content,
    }: CreateCommentReplyParams): Promise<CommentReply> {
        const response = await api.post(`/commentreply`, {
            reviewQuestionAnswerId,
            content,
        });
        return response.data;
    },
};
